// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box-viewer{position:relative;display:block;overflow:hidden}.content-box-viewer .is-wrapper{min-height:600px}.content-box-viewer--no-pace .is-wrapper{opacity:1 !important}", ""]);
// Exports
module.exports = exports;
